import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import "react";
import { GridCellCheckboxRenderer } from "../components/columnSelection/GridCellCheckboxRenderer.es.js";
import { GridHeaderCheckbox } from "../components/columnSelection/GridHeaderCheckbox.es.js";
import { selectedIdsLookupSelector } from "../hooks/features/rowSelection/gridRowSelectionSelector.es.js";
import { GRID_BOOLEAN_COL_DEF } from "./gridBooleanColDef.es.js";
import { j as jsxRuntimeExports } from "../../../react/jsx-runtime.es.js";
const GRID_CHECKBOX_SELECTION_FIELD = "__check__";
const GRID_CHECKBOX_SELECTION_COL_DEF = _extends({}, GRID_BOOLEAN_COL_DEF, {
  field: GRID_CHECKBOX_SELECTION_FIELD,
  type: "checkboxSelection",
  width: 50,
  resizable: false,
  sortable: false,
  filterable: false,
  // @ts-ignore
  aggregable: false,
  disableColumnMenu: true,
  disableReorder: true,
  disableExport: true,
  getApplyQuickFilterFn: void 0,
  getApplyQuickFilterFnV7: void 0,
  valueGetter: (params) => {
    const selectionLookup = selectedIdsLookupSelector(params.api.state, params.api.instanceId);
    return selectionLookup[params.id] !== void 0;
  },
  renderHeader: (params) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridHeaderCheckbox, _extends({}, params)),
  renderCell: (params) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridCellCheckboxRenderer, _extends({}, params))
});
export {
  GRID_CHECKBOX_SELECTION_COL_DEF,
  GRID_CHECKBOX_SELECTION_FIELD
};
//# sourceMappingURL=gridCheckboxSelectionColDef.es.js.map
